(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Transaction.Capture.Questionnaire",
                {
                    url: "/Questionnaire",
                    component: "captureQuestionnaire",
                    resolve: {
                        categories: ["transactionQuestionApi", "$stateParams", function (transactionQuestionApi, $stateParams) {
                            return transactionQuestionApi.getTransactionQuestionCategories($stateParams.transactionId);
                        }],
                        prevStage: [
                            "transaction", "transactionApi", "_", function (transaction, transactionApi, _) {
                                var currIndex = _.findIndex(transaction.CapturePoints,
                                    function (capturePoint) {
                                        return capturePoint === "Questionnaire";
                                    });

                                if (currIndex === 0) {
                                    return transactionApi.getDisclosures(transaction.Id).then(function(disclosures) {
                                        return disclosures.length === 0 ? null : "Transaction.Disclose";
                                    });
                                } else return "Transaction.Capture." + transaction.CapturePoints[currIndex - 1];
                            }
                        ],
                        nextStage: [
                            "transaction", "_", function (transaction, _) {
                                var currIndex = _.findIndex(transaction.CapturePoints,
                                    function (capturePoint) {
                                        return capturePoint === "Questionnaire";
                                    });

                                return currIndex === transaction.CapturePoints.length - 1
                                    ? "Transaction.Determine.ProductChoice"
                                    : "Transaction.Capture." + transaction.CapturePoints[currIndex + 1];
                            }
                        ]
                    },
                    onEnter: ["transactionApi", "transaction", function (transactionApi, transaction) {
                        transaction.LastTransactionStage = "Questionnaire";
                        transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                    }]
                });
        }
    ]);

    app.component("captureQuestionnaire",
        {
            templateUrl: "/App/Transaction/Capture/Questionnaire/template.html",
            controller: captureQuestionnaireController,
            bindings: {
                prevStage: "<",
                nextStage: "<",
                categories: "<",
                transaction: "<"
            }
        });

    captureQuestionnaireController.$inject = ["$scope", "$state", "transactionQuestionApi", "$q"];
    function captureQuestionnaireController($scope, $state, transactionQuestionApi, $q) {
        $scope.$parent.$ctrl.getCurrentStage($state);
        var $ctrl = this;
        ng.extend($ctrl,
            {
                toggleCheckBoxAnswer: toggleCheckBoxAnswer,
                lastCategory: lastCategory,
                advanceCategory: advanceCategory,
                updateAnswer: updateAnswer,
                saveQuestion: saveQuestion,
                bounce: bounce,
                UI: {}
            });
        // original function for mass saving
        //function updateAnswers() {
        //    var promises = [];
        //    ng.forEach($ctrl.categories, function (cat) {
        //        ng.forEach(cat.QuestionList, function (q) {
        //            if (q.Type === "LongText" || q.Type === "ShortText" || q.TextAnswer !== null)
        //                promises.push(transactionQuestionApi.updateTextAnswer({ Id: q.Id, Type: q.Type, TextAnswer: { Answer: q.Answer || "" } }));
        //            else if (q.Type === "SelectOne" && (q.Answer || q.Answer === 0) || q.SelectOneAnswer !== null)
        //                promises.push(transactionQuestionApi.updateSelectOneAnswer({
        //                    Id: q.Id, Type: q.Type, SelectOneAnswer: { Answer: q.Answer, Explanation: q.PossibleAnswers[q.Answer].Explanation || "" }
        //                }));
        //            else if ((q.Type === "SelectMany" && q.Answer.length) || q.SelectManyAnswer !== null) {
        //                var answer = { Id: q.Id, Type: q.Type, SelectManyAnswer: { Answer: {} } };
        //                ng.forEach(q.Answer, function (ans) {
        //                    answer.SelectManyAnswer.Answer[ans] = q.PossibleAnswers[ans].Explanation || "";
        //                });
        //                promises.push(transactionQuestionApi.updateSelectManyAnswer(answer));
        //            }

        //        });
        //    });
        //    return $q.all(promises);
        //}

        function bounce() {
            if (!($ctrl.categories.length === $ctrl.currentCategory + 1 &&
                $ctrl.categories[$ctrl.currentCategory].QuestionList.length === $ctrl.currentQuestion + 1)) {
                $ctrl.UI.bounceAnimation = true;

                setTimeout(function () {
                    $ctrl.UI.bounceAnimation = false;
                },
                    1000);

            }
        }

        function next(catIndex, qIndex) {
            if ($ctrl.categories[catIndex].QuestionList.length > (qIndex + 1))
                $ctrl.currentQuestion = qIndex + 1;
            else
                $ctrl.advanceCategory();

        }

        function saveQuestion(catIndex, qIndex) {

            if (!($ctrl.categories.length === catIndex + 1 && $ctrl.categories[catIndex].QuestionList.length === qIndex + 1)) {
                if (!$ctrl.categories[catIndex].QuestionList[qIndex].Required) {
                    next(catIndex, qIndex);
                } else {
                    if ($ctrl.categories[catIndex].QuestionList[qIndex].Type === "SelectOne" &&
                        ($ctrl.categories[catIndex].QuestionList[qIndex].Answer ||
                            $ctrl.categories[catIndex].QuestionList[qIndex].Answer === 0)) {
                        next(catIndex, qIndex);
                    } else {
                        if ($ctrl.categories[catIndex].QuestionList[qIndex].Answer.length) {
                            next(catIndex, qIndex);
                        }
                    }

                }
            }
            $ctrl.updateAnswer(catIndex, qIndex);
        }

        function updateAnswer(catIndex, qIndex) {
            var q = $ctrl.categories[catIndex].QuestionList[qIndex];

            if (q.Type === "LongText" || q.Type === "ShortText" || q.TextAnswer !== null)
                return transactionQuestionApi.updateTextAnswer({ Id: q.Id, Type: q.Type, TextAnswer: { Answer: q.Answer || "" } });
            else if (q.Type === "SelectOne" && (q.Answer || q.Answer === 0) || q.SelectOneAnswer !== null)
                return transactionQuestionApi.updateSelectOneAnswer({
                    Id: q.Id, Type: q.Type, SelectOneAnswer: { Answer: q.Answer, Explanation: q.PossibleAnswers[q.Answer].Explanation || "" }
                });
            else if ((q.Type === "SelectMany" && q.Answer.length) || q.SelectManyAnswer !== null) {
                var answer = { Id: q.Id, Type: q.Type, SelectManyAnswer: { Answer: {} } };
                ng.forEach(q.Answer, function (ans) {
                    answer.SelectManyAnswer.Answer[ans] = q.PossibleAnswers[ans].Explanation || "";
                });
                return transactionQuestionApi.updateSelectManyAnswer(answer);
            }
            return false;
        }

        this.$onInit = function() {
            ng.forEach($ctrl.categories, function (cat) {
                ng.forEach(cat.QuestionList, function (q) {
                    if (q.TextAnswer !== null) {
                        q.Answer = q.TextAnswer.Answer;
                    }
                    else if (q.SelectOneAnswer !== null) {
                        q.Answer = q.SelectOneAnswer.Answer;
                        q.PossibleAnswers[q.Answer].Explanation = q.SelectOneAnswer.Explanation;
                    }
                    else if (q.SelectManyAnswer !== null) {
                        q.Answer = [];
                        for (var key in q.SelectManyAnswer.Answer) {
                            if (q.SelectManyAnswer.Answer && q.SelectManyAnswer.Answer.hasOwnProperty(key)) {

                                q.Answer.push(parseInt(key));
                                q.PossibleAnswers[key].Explanation = q.SelectManyAnswer.Answer[key];
                            }
                        }
                    }

                });
            });
        };

        $ctrl.currentCategory = 0;
        $ctrl.currentQuestion = 0;

        function lastCategory(index) {
            $ctrl.currentCategory = $ctrl.currentCategory - 1;
            $ctrl.currentQuestion = $ctrl.categories[index].QuestionList.length - 1;
        }
        function advanceCategory() {
            $ctrl.currentCategory = $ctrl.currentCategory + 1;
            $ctrl.currentQuestion = 0;
        }
        function toggleCheckBoxAnswer(clicked) {
            var index = $ctrl.categories[$ctrl.currentCategory].QuestionList[$ctrl.currentQuestion].Answer.indexOf(clicked);
            if (index > -1) {
                $ctrl.categories[$ctrl.currentCategory].QuestionList[$ctrl.currentQuestion].Answer.splice(index, 1);
            }
            else {
                $ctrl.categories[$ctrl.currentCategory].QuestionList[$ctrl.currentQuestion].Answer.push(clicked);
            }
        };

        $ctrl.showHideTest = false;
    };// END CONTROLLER

})(window.app, window.angular); //jshint ignore:line